import { RequestStatusEnum } from '../../project/requests/type/request-status.enum';

export enum BLOB_TYPE {
  WORD = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PDF = 'application/pdf',
}

export enum CLASS_NAME {
  IS_SELECTED = 'isSelected',
  IS_DISABLED = 'isDisabled',
  IS_VISIBLE = 'isVisible',
  IS_ACTIVE = 'isActive',
  IS_READY = 'isReady',
  IS_HIDDEN = 'isHidden',
  IS_UPDATING = 'isUpdating',
  IS_EXPANDED = 'isExpanded',
  IS_REMOVED = 'isRemoved',
  IS_COPIED = 'isCopied',
  IS_HOVERED = 'isHovered',

  WAS_CREATED = 'wasCreated',
  WAS_DELETED = 'wasDeleted',
}

export enum EVENT_TYPE {
  READY = 'ready',
  CLICK = 'click',
}

export enum ORDER_TYPE {
  TEST = 'test',
  SET_VALUE = 'setValue',
  GET_VALUE = 'getValue',
  TOGGLE_CLASS = 'toggleClass',
  OPEN = 'open',
  CLOSE = 'close',
}

export enum SELECTION_STATE {
  NONE = 'NONE',
  ONE = 'ONE',
  SOME = 'SOME',
  ALL = 'ALL',
  SUCCEED = 'SUCCEED',
  FAILED = 'FAILED',
  SWITCH_INDETERMINATE = 'INDETERMINATE',
}

export enum API_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export enum API_COMMON {
  PROJECTS = 'projects',
  REQUESTS = 'requests',
  INVOICES = 'invoices',
  LICENSES = 'licenses',
  JOBS = 'jobs',
  FEATURE_FLAG = 'feature-flag',
  USERS = 'users',
  ALBUM = 'album',
  ALBUMS = 'albums',
  SAP_TERRITORIES = 'sap-territories',
}

export enum FILTER_OPERATION {
  INCLUDE = 'include',
  EXCLUDE = 'exclude',
}

export enum ERROR_PRIORITY {
  WARNING = 'WARNING',
  MODERATE = 'MODERATE',
  CRITICAL = 'CRITICAL',
  ANY = 'ANY',
}

export enum ERROR_TYPE {
  API_ERROR = 'API_ERROR',
  UI_ERROR = 'UI_ERROR',
}

export enum ASYNC_JOB_STATUS {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  FAIL = 'FAIL',
}

export enum FEATURE_FLAG {
  HANDLE_ERROR_MESSAGES = 'HANDLE_ERROR_MESSAGES',
  DISCO_INTEGRATION = 'DISCO_INTEGRATION',
  ENABLE_PROJECTS_MERGE = 'ENABLE_PROJECTS_MERGE',
  ENABLE_MLR_PROJECTS = 'ENABLE_MLR_PROJECTS',
  TERM_AND_OPTION_BULK_EDIT = 'TERM_AND_OPTION_BULK_EDIT',
  ENABLE_BULK_STATUS_EDIT_FOR_MSR = 'ENABLE_BULK_STATUS_EDIT_FOR_MSR',
  TERM_AND_OPTION_BULK_EDIT_FOR_MSR = 'TERM_AND_OPTION_BULK_EDIT_FOR_MSR',
  REQUEST_LEVEL_PRODUCTION_NAME_FOR_MSR = 'REQUEST_LEVEL_PRODUCTION_NAME_FOR_MSR',
  ENABLE_NON_AUDIO_BULK_UPLOAD = 'ENABLE_NON_AUDIO_BULK_UPLOAD',
  ENABLE_RECORDING_AUDIO_REPLACE = 'ENABLE_RECORDING_AUDIO_REPLACE',
  ENABLE_AIMS = 'ENABLE_AIMS',
  ENABLE_MCR_PROJECTS = 'ENABLE_MCR',
  ENABLE_RECORDING_SEARCH_TABLE_VIEW = 'ENABLE_RECORDING_SEARCH_TABLE_VIEW',
  ENABLE_RECORDING_SOFT_DELETE = 'ENABLE_RECORDING_SOFT_DELETE',
  GCDM_CREDIT_SYNC = 'GCDM_CREDIT_SYNC',
  ANCILLARY_PRODUCT = 'ANCILLARY_PRODUCT',
  MSR_PAYMENT_SOFT_DELETE = 'MSR_PAYMENT_SOFT_DELETE',
  ENABLE_GPI_DATA = 'ENABLE_GPI_DATA',
  ENABLE_SUPER_BULK_UPLOADER = 'ENABLE_SUPER_BULK_UPLOADER',
  // Remote key stays 'GLS_PLAYER_V2' to match the backend-registered flag.
  GLS_PLAYER_NEXT = 'GLS_PLAYER_V2',
}

export enum SORTING_ORDER {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const ERROR_PRIORITY_LABELS = {
  [ERROR_PRIORITY.WARNING]: 'Warning',
  [ERROR_PRIORITY.MODERATE]: 'Non-Critical',
  [ERROR_PRIORITY.CRITICAL]: 'Critical',
  [ERROR_PRIORITY.ANY]: 'All',
};

export const REQUEST_STATUS_COLORS = {
  [RequestStatusEnum.IN_PROGRESS]: '#97c94b',
  [RequestStatusEnum.PENDING_APPROVAL]: '#e8be04',
  [RequestStatusEnum.APPROVED]: '#e07a30',
  [RequestStatusEnum.BALLPARK]: '#6bc5c8',
  [RequestStatusEnum.QUOTED]: '#008642',
  [RequestStatusEnum.DENIED]: '#d45252',
  [RequestStatusEnum.DEAD]: '#716058',
  [RequestStatusEnum.USED]: '#008642',
  [RequestStatusEnum.SENT_TO_LICENSING]: '#7050ad',
  [RequestStatusEnum.COMPLETE]: '#0061ab',
  [RequestStatusEnum.EXPIRED]: '#b92c80',
  DISABLED: '#c1c4c9',
};

export const MSR_WMG_REQUEST_STATUS_COLORS = {
  [RequestStatusEnum.IN_PROGRESS]: '#007A36',
  [RequestStatusEnum.PENDING_APPROVAL]: '#866400',
  [RequestStatusEnum.APPROVED]: '#CA5010',
  [RequestStatusEnum.BALLPARK]: '#1A676A',
  [RequestStatusEnum.QUOTED]: '#0061AB',
  [RequestStatusEnum.DENIED]: '#BC3C3C',
  [RequestStatusEnum.DEAD]: '#3F3F3F',
  [RequestStatusEnum.USED]: '#007A36',
  [RequestStatusEnum.SENT_TO_LICENSING]: '#7050AD',
  [RequestStatusEnum.COMPLETE]: '#004E89',
  [RequestStatusEnum.EXPIRED]: '#000000',
  DISABLED: '#c1c4c9',
};

export const REQUEST_STATUS_ICONS = {
  [RequestStatusEnum.IN_PROGRESS]: 'fa-flag',
  [RequestStatusEnum.PENDING_APPROVAL]: 'fa-adjust',
  [RequestStatusEnum.APPROVED]: 'fa-check-circle',
  [RequestStatusEnum.BALLPARK]: 'fa-money',
  [RequestStatusEnum.QUOTED]: 'fa-money',
  [RequestStatusEnum.DENIED]: 'fa-ban',
  [RequestStatusEnum.DEAD]: 'fa-window-close-o',
  [RequestStatusEnum.USED]: 'fa-check-circle-o',
  [RequestStatusEnum.SENT_TO_LICENSING]: 'fa-gavel',
  [RequestStatusEnum.COMPLETE]: 'fa-calendar-check-o',
  [RequestStatusEnum.EXPIRED]: 'fa-calendar-times-o',
};

export const SELECTION_STATE_ICONS = {
  [SELECTION_STATE.NONE]: 'fa-square-o',
  [SELECTION_STATE.ONE]: 'fa-check-square',
  [SELECTION_STATE.SOME]: 'fa-minus-square',
  [SELECTION_STATE.ALL]: 'fa-check-square',
  [SELECTION_STATE.SUCCEED]: 'fa-check',
  [SELECTION_STATE.FAILED]: 'fa-exclamation-circle',
};

export const SELECTION_STATE_LABELS = {
  [SELECTION_STATE.NONE]: 'SELECT ONLY this Request',
  [SELECTION_STATE.ONE]: 'SELECT ONLY this Request',
  [SELECTION_STATE.SOME]: 'SELECT ONLY this Request',
  [SELECTION_STATE.ALL]: 'DESELECT ONLY this Request',
  [SELECTION_STATE.SUCCEED]: 'This Request already has Selection on this Invoice',
};

export enum REGARDS_COMPANY {
  AT = 'AUSTRIA',
  BR = 'BRAZIL',
  CH = 'SWITZERLAND',
  DE = 'GERMANY',
  SE = 'SWEDEN',
  NO = 'NORWAY',
  DK = 'DENMARK',
  FI = 'FINLAND',
  CA = 'CANADA',
  CL = 'CHILE',
  HK = 'HONG_KONG',
  PH = 'PHILIPPINES',
  SG = 'SINGAPOUR',
  TW = 'THAIWAN',
  TH = 'THAILAND',
  VN = 'VIETNAM',
  /** GLSS-7689 fix */
  BE = 'BELGIUM',
  NL = 'NETHERLANDS',
  MY = 'MALAYSIA',
  AR = 'ARGENTINA',
  MX = 'MEXICO',
  CO = 'COLOMBIA',
  UY = 'URUGUAY',

  // Disabled till release 3.13.2
  ES = 'SPAIN',
  PT = 'PORTUGAL',
  GB = 'UNITED_KINGDOM',
  /** new 6 territories, May 2025 */
  US = 'USA',
  IT = 'ITALY',
  KR = 'SOUTH KOREA',
  CN = 'CHINA',
  FR = 'FRANCE',
  AU = 'AUSTRALIA',

  /** GLSS-8039 */
  LU = 'LUXEMBOURG',

  ID = 'INDONESIA',
  PE = 'PERU',
}

export enum MSR_REGARDS_COMPANY {
  AU = 'AUSTRALIA',
  AT = 'AUSTRIA',
  CA = 'CANADA',
  CN = 'CHINA',
  CO = 'COLOMBIA',
  DK = 'DENMARK',
  FI = 'FINLAND',
  FR = 'FRANCE',
  DE = 'GERMANY',
  HK = 'HONG_KONG',
  ID = 'INDONESIA',
  MY = 'MALAYSIA',
  NZ = 'NEW_ZEALAND',
  NO = 'NORWAY',
  PE = 'PERU',
  PH = 'PHILIPPINES',
  PT = 'PORTUGAL',
  SG = 'SINGAPOUR',
  KR = 'SOUTH_KOREA',
  ES = 'SPAIN',
  SE = 'SWEDEN',
  CH = 'SWITZERLAND',
  TW = 'THAIWAN',
  TH = 'THAILAND',
  GB = 'UNITED_KINGDOM',
  US = 'USA',
}

export const FIT_TERRITORIES = [
  'CA',
  'CL',
  'HK',
  'PH',
  'SG',
  'TW',
  'TH',
  'VN',
  'AR',
  'BE',
  'BR',
  'CO',
  'DK',
  'FI',
  'MX',
  'MY',
  'NL',
  'NO',
  'SE',
  'UY',

  // Disabled till release 3.13.2
  'AT',
  'CH',
  'DE',
  'ES',
  'PT',
  'GB',

  /** GLSS-8039 */
  'LU',

  /** GLSS-9226: PSR WCM Invoices: remove ADD PAYMENT button */
  /** GLSS-9230: PSR May FY25:Disable edit for SAP/S4 contacts */
  /** new 6 territories, May 2025 */
  'US',
  'IT',
  'KR',
  'CN',
  'FR',
  'AU',
];
